<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col>-->
        <v-col cols="4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                dark
                v-bind="attrs"
                v-on="on"
                @click="import_dailog = true"
                class="ml-7 header_btn"
                :disabled="selectedRows.length > 0"
              >
                <v-icon size="28px">mdi-download-outline</v-icon>
                <span class="lable_class">Import</span>
              </v-btn>
            </template>
            <span>Import Item</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-7 header_btn"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length > 0"
                @click="addRecord()"
              >
                <v-icon size="28px">mdi-file-plus-outline</v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                :to="(selectedRows[0])?'items/edit/'+selectedRows[0].item_id:''"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-clipboard-edit-outline</v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                :to="(selectedRows[0])?'items/edit/'+selectedRows[0].item_id:''"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-eye-outline</v-icon>
                <span class="lable_class">View</span>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0 || open_doc_model_falg || open_log_model_falg"
                @click="delete_dialog = true"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-delete-outline</v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="assignGroupDialog(true)"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-plus-circle-multiple-outline</v-icon>
                <span class="lable_class">Assign</span>
              </v-btn>
              <!-- <v-btn
                @click="assignGroupDialog(true)"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0 || (getTotalStoneCount > 0 && getTotalItemCount > 0)"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-plus-circle-multiple-outline</v-icon>
                <span class="lable_class">Assign</span>
              </v-btn>-->
            </template>
            <span>Assign group on selected records</span>
          </v-tooltip>
        </v-col>

        <v-col cols="1" class="d-flex align-center">
          <!-- <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn :disabled="open_doc_model_falg || open_log_model_falg" icon  dark v-bind="attrs" v-on="on">
                <v-badge overlap dot :value="search || pagination.filters.alphabet" color="error">
                  <v-icon size="28px">mdi-magnify</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="400">
              <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                  solo
                  clearable
                  autofocus
                  v-on:keyup.enter="search_menu = false"
                ></v-text-field>
              </v-col>
              </v-row>
            </v-card>
          </v-menu>-->
          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="filter_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="pagination.filters.alphabet = ''"
                :disabled="open_doc_model_falg || open_log_model_falg"
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="ml-7 header_btn"
              >
                <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                <span class="lable_class">Filter</span>
              </v-btn>
            </template>
            <v-card tile max-width="400" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-list-item class="mt-0">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    hide-details
                    dense
                    outlined
                    placeholder=" "
                    clearable
                    autofocus
                    v-on:keyup.enter="search_menu = false"
                    class="mr-2"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="error"
                        @click="resetFilter()"
                        icon
                        small
                      >
                        <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Reset</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item class="mt-1">
                  <v-autocomplete
                    dense
                    flat
                    :items="status"
                    outlined
                    label="Status"
                    hide-details
                    class="body-2"
                    placeholder=" "
                    v-model="pagination.filters.item_active"
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item class="mt-1">
                  <v-autocomplete
                    dense
                    flat
                    :items="item_stone_list"
                    outlined
                    label="Item/Stone"
                    hide-details
                    class="body-2"
                    placeholder=" "
                    v-model="pagination.filters.item_stone"
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item class="mt-1">
                  <v-autocomplete
                    dense
                    flat
                    :items="group_list"
                    outlined
                    label="Group"
                    item-text="name"
                    item-value="invoice_group_id"
                    hide-details
                    class="body-2"
                    placeholder="All"
                    v-model="pagination.filters.item_group"
                    clearable
                  ></v-autocomplete>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>

        <v-col cols="2">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openDocList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-7 header_btn"
              >
                <span class="lable_class">Documents</span>
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].docs_count:''"
                  overlap
                >
                  <v-icon size="28px">mdi-dresser-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Documents</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="openLogList(selectedRows[0])"
                :disabled="selectedRows.length != 1"
                class="ml-7 header_btn"
              >
                <span class="lable_class">Logs</span>
                <v-badge
                  color="error"
                  :content="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  :value="(selectedRows[0] && selectedRows.length == 1)?selectedRows[0].logs_count:''"
                  overlap
                >
                  <v-icon size="22px">mdi-file-document-multiple-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Logs</span>
          </v-tooltip>
        </v-col>

        <v-col cols="2">
          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="setting_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" class="ml-1 header_btn">
                <v-icon size="28px">mdi-cog-outline</v-icon>
                <span class="lable_class">Settings</span>
              </v-btn>
            </template>
            <v-card tile max-width="295" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-row dense class="pl-3 pr-3 pt-1">
                  <v-col cols="12">Total: {{totalPer}}%</v-col>
                  <v-col cols="6">
                    <v-text-field
                      dense
                      flat
                      outlined
                      label="Sales Tax %"
                      hide-details
                      class="body-2"
                      placeholder=" "
                      type="number"
                      v-model="setting_data.sales_tax"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      dense
                      flat
                      outlined
                      label="Finance Cost %"
                      hide-details
                      class="body-2"
                      placeholder=" "
                      type="number"
                      v-model="setting_data.finance_cost"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      dense
                      flat
                      outlined
                      label="Markup %"
                      hide-details
                      class="body-2"
                      placeholder=" "
                      type="number"
                      v-model="setting_data.markup"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      dense
                      flat
                      outlined
                      label="Delivery Cost"
                      hide-details
                      class="body-2"
                      placeholder=" "
                      type="number"
                      v-model="setting_data.delivery_cost"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      small
                      @click="updateSetting('yes')"
                      block
                      color="primary"
                      class="text-capitalize"
                    >Update All</v-btn>
                  </v-col>
                  <v-col class="text-right">
                    <v-btn
                      small
                      @click="updateSetting('no')"
                      color="primary"
                      class="text-capitalize"
                    >Update Future Records</v-btn>
                  </v-col>
                </v-row>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="setting_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="3" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            Item
            <v-icon
              class="error--text ml-2"
              size="30"
              style="color:#ffffff !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background:none" flat>
      <v-card-text class="pa-0 mx-auto">
        <v-row dense style="width:100%" class="pa-0 ma-0">
          <v-col cols="2" class="pt-0 pr-0 alphabet-sort-max-width">
            <v-row dense class="alphabet-section">
              <v-col cols="12" class="text-center">
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:15px;"
                  :class="(pagination.filters.alphabet == '')?'primary':''"
                  class="text-capitalize"
                  @click="pagination.filters.alphabet = ''"
                >All</v-btn>
              </v-col>

              <v-col
                cols="12"
                v-for="(alphabet, index) in alphabets"
                :key="index"
                class="text-center pa-0"
                :style="alphabet.text == 'Z' 
                  ? 'padding-top: 1px !important; padding-bottom: 11px !important;' 
                  : 'padding-bottom: 2px !important;'"
              >
                <v-btn
                  elevation="2"
                  max-width="22"
                  min-width="22"
                  height="20"
                  small
                  style="font-size:14px;"
                  :disabled="alphabet.disable"
                  :class="(pagination.filters.alphabet == alphabet.value) ? 'primary' : ''"
                  @click="pagination.filters.alphabet = alphabet.value"
                >{{ alphabet.text }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-0 pr-0">
            <v-data-table
              :headers="headers"
              item-key="item_id"
              class="full-footer-bar elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header custom-width-1328"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              mobile-breakpoint="50"
              :show-expand="true"
              single-expand
              :expanded.sync="expanded"
              @item-expanded="expandRow"
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
              dense
            >
              <template v-slot:item="{item}">
                <tr :class="(!item.item_active)?'red lighten-5':''">
                  <td width="3%">
                    <v-icon
                      @click="editRecord(item.item_id,false)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-clipboard-edit-outline</v-icon>
                  </td>
                  <td width="3%" class="pl-3">
                    <v-simple-checkbox
                      @input="selectRecord(item.item_id)"
                      class="custom-simple-box"
                      v-model="item.selected"
                      :ripple="false"
                    ></v-simple-checkbox>
                  </td>
                  <td
                    class="pl-7"
                    width="8%"
                  >{{ (item.item_type ==1) ? 'Stone' : item.item_type==2 ? 'Job' : 'Item'}}</td>
                  <td width="30%">{{item.item_name}}</td>
                  <td width="35%">{{(item.invoicegroup)?item.invoicegroup.name:''}}</td>
                  <td
                    width="9%"
                    class="pl-3"
                  >{{(item.vendors[0] && item.vendors[0].sales_price > 0)?'$'+item.vendors[0].sales_price: ''}}</td>
                  <td width="9%" class="pl-3">{{(item.uom)?item.uom.ioum_title:''}}</td>
                  <!-- <td width="6%">
                   
                  </td>
                  <td width="8%">
                   <v-switch
                      v-if="item.vendors[0]"
                      class="pt-0 ma-0 ml-11"
                      v-model="item.vendors[0].price_override"
                      color="success"
                      dense=""
                      @change="updateItem(index)"
                      hide-details
                    ></v-switch>
                  </td>
                  <td width="6%">
                   <v-text-field 
                      style="margin-top: -2px;"
                      v-if="item.vendors[0] && item.vendors[0].price_override"
                      v-model="item.vendors[0].override_price"
                      v-on:keyup="updateItem(index)"
                      type="number"
                      dense
                      hide-details
                    ></v-text-field>
                  </td>
                  <td width="5%" class="text-center">-->
                  <!-- {{(item.item_active)?'Yes':'No'}} -->
                  <!-- <v-switch
                      class="pt-0 ma-0 pl-3"
                      v-model="item.item_active"
                      color="success"
                      @change="updateItem(index)"
                      dense=""
                      hide-details
                    ></v-switch>
                  </td>
                  <td width="6%" class="text-center">
                    <v-tooltip bottom v-if="item.on_sale">
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                        >Yes</span>
                      </template>
                      <span>Discount: {{item.discount}} | Start Dt: {{item.start_date}} | End Dt: {{item.end_date}}</span>
                    </v-tooltip>
                    <span v-else>
                      No
                    </span>
                  </td>-->

                  <td width="3%">
                    <v-icon
                      @click="editRecord(item.item_id,true)"
                      :disabled="open_doc_model_falg || open_log_model_falg"
                    >mdi-eye-outline</v-icon>
                  </td>
                </tr>
              </template>
              <template v-slot:header.select_all>
                <v-simple-checkbox
                  v-model="select_all_checkbox"
                  @input="changeSelectAll()"
                  color="white"
                  :ripple="false"
                  class="select-all-checkbox custom-simple-box"
                ></v-simple-checkbox>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="preview_image_dialog" max-width="800px">
      <v-card>
        <v-btn class="ma-1" small fab color="error" @click="deleteImage">
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
        <v-card-text class="pl-3 pr-3 pb-1 pt-1">
          <v-tabs-items
            v-model="tab"
            class="d-flex align-center justify-center"
            style="min-height: 485px;"
          >
            <v-tab-item v-for="(image_details) in images" :key="image_details.item_img_id">
              <img :src="image_details.image_url" style="max-width:100%; max-height: 100%" />
            </v-tab-item>
          </v-tabs-items>
          <div style="position:sticky; bottom: 1px; width: 100%">
            <v-tabs v-model="tab" align-with-title show-arrows centered>
              <v-tab
                v-for="(image_data, index) in images"
                :key="image_data.item_img_id"
                @click="activeImage(index)"
              >
                <v-img
                  :aspect-ratio="16/9"
                  contain
                  :src="image_data.image_url"
                  max-height="90"
                  max-width="90"
                ></v-img>
              </v-tab>
            </v-tabs>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete selected items?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteItems()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="import_dailog" max-width="400" persistent>
      <v-card :loading="import_dailog_loading">
        <v-card-title class="headline d-flex justify-center">Import Item</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-file-input
                accept=".csv, .xlsx, .xls"
                v-model="selected_file"
                hide-details
                outlined
                placeholder="Select File"
                dense
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="import-btn">
          <v-btn color="error" dark @click="import_dailog = false; selected_file = null">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!selected_file"
            color="primary"
            dark
            @click="importData"
            :loading="import_dailog_loading"
          >Import</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="assign_group_dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Assign Group</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete
                  :items="assign_group_list"
                  label="Group Name"
                  dense
                  v-model="selected_group"
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="assign_group_dialog = false;selected_group = '';">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="selected_group.length == 0" @click="assignGroups">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Add />
    <Edit />
    <Upload />
    <DocList />
    <LogList />
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import Add from "./Add";
import Edit from "./Edit";
import Upload from "../document/Upload";
import DocList from "../document/List";
import LogList from "../log/List";
import { parseParams, logout } from "../../plugins/helper";
import { mapMutations, mapState } from "vuex";
export default {
  name: "ProjectList",
  data() {
    return {
      open_doc_model_falg: false,
      open_log_model_falg: false,
      setting_data: {},
      tab: null,
      loading: false,
      delete_dialog: false,
      group_list: [],
      preview_image_dialog: false,
      import_dailog_loading: false,
      import_dailog: false,
      selected_file: null,
      preview_image: "",
      search: "",
      items: {
        current_page: 1,
        per_page: 10,
        data: []
      },
      filter_menu: false,
      setting_menu: false,
      active_image_index: 0,
      status: [
        { text: "All", value: "all" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      item_stone_list: [
        { text: "All", value: "all" },
        { text: "Item", value: "0" },
        { text: "Stone", value: "1" },
        { text: "Job", value: "2" }
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["item_name"],
        page: 1,
        filters: {
          item_active: "1",
          item_stone: "all",
          alphabet: "",
          item_group: ""
        }
      },
      alphabets: [],
      expanded: [],
      images: "",
      search_menu: false,
      assign_group_dialog: false,
      form_loading: false,
      selected_group: "",
      assign_group_list: [],
      item_count: 0,
      select_all_checkbox: false
    };
  },
  components: {
    Add,
    Edit,
    Upload,
    LogList,
    DocList
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("item", ["add_item_modal", "edit_item_modal"]),
    ...mapState("document", ["doc_list_modal", "refresh_doc_list"]),
    ...mapState("log", ["log_list_modal", "refresh_log_list"]),
    totalPer() {
      let total = 0;
      if (this.setting_data.sales_tax) {
        total += parseFloat(this.setting_data.sales_tax);
      }
      if (this.setting_data.finance_cost) {
        total += parseFloat(this.setting_data.finance_cost);
      }
      if (this.setting_data.markup) {
        total += parseFloat(this.setting_data.markup);
      }
      return total;
    },
    getTotalStoneCount() {
      let ids = [];
      this.selectedRows.map(function(item) {
        if (item.item_type == "1") {
          ids.push(item.item_id);
        }
      });
      console.log("stone.length", ids.length);
      return ids.length;
    },
    getTotalItemCount() {
      let ids = [];
      this.selectedRows.map(function(item) {
        if (item.item_type == "0") {
          ids.push(item.item_id);
        }
      });
      console.log("item.length", ids.length);
      return ids.length;
    },
    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "p_name";
      return paginationData;
    },
    getStyles() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return {
          maxWidth: "95%",
          margin: "0 auto"
        };
      } else {
        return {};
      }
    },
    headers() {
      return [
        { value: "", text: "", sortable: false, width: "3%" },
        {
          value: "select_all",
          text: "#",
          sortable: false,
          width: "3%",
          class: "pl-2"
        },
        { value: "item_type", text: "Type", sortable: true, width: "8%" },
        { value: "item_name", text: "Name", sortable: true, width: "30%" },
        { value: "", text: "Group", sortable: false, width: "35%" },
        { value: "", text: "Sales Price", sortable: false, width: "9%" },
        { value: "", text: "UOM", sortable: false, width: "9%" },
        // { value : '',text : 'Stock',sortable : false, width: '6%'},
        // { value : '',text : 'Px. Override',sortable : false, width: '8%' },
        // { value : '',text : 'Price',sortable : false, width: '6%' },
        // { value : '',text : 'Active',sortable : false, width: '5%' },
        // { value : '',text : 'On Sale',sortable : false, width: '6%'},
        { value: "", text: "", sortable: false, width: "3%" }
      ];
    }
  },
  watch: {
    doc_list_modal: function(value) {
      if (!value) {
        this.open_doc_model_falg = false;
      } else {
        this.open_doc_model_falg = true;
      }
    },
    log_list_modal: function(value) {
      if (!value) {
        this.open_log_model_falg = false;
      } else {
        this.open_log_model_falg = true;
      }
    },
    search() {
      this.getItems();
    },
    pagination: {
      handler: function() {
        this.getItems();
      },
      deep: true
    },
    add_item_modal: function(value) {
      if (!value) {
        this.pagination.filters.alphabet = "";
        this.resetFilter();
      }
    },
    edit_item_modal: function(value) {
      if (!value) {
        this.getItems();
      }
    }
  },
  methods: {
    ...mapMutations("item", ["setItemData"]),
    ...mapMutations("utils", ["setAlert"]),
    ...mapMutations("document", ["setModal", "setDocumentData"]),
    ...mapMutations("log", ["setLogData"]),
    changeSelectAll() {
      if (this.select_all_checkbox) {
        this.items.data = this.items.data.map(item => {
          item.selected = true;
          return item;
        });
      } else {
        this.items.data = this.items.data.map(item => {
          item.selected = false;
          return item;
        });
      }
    },
    updateItem(index) {
      axios
        .post("inline_edit_item", this.items.data[index])
        .then(function() {})
        .catch(function(error) {
          console.log("FAILURE!!", error);
        });
    },
    resetFilter() {
      this.search = "";
      this.pagination.filters.item_active = "1";
      this.pagination.filters.item_stone = "all";
      this.pagination.filters.item_group = "";
      this.getItems();
    },
    selectRecord(val) {
      if (this.open_doc_model_falg || this.open_log_model_falg) {
        this.items.data.filter(item => {
          if (val == item.item_id) {
            if (this.open_doc_model_falg && this.open_log_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openDocList(item);
              this.openLogList(item);
              setTimeout(() => {
                this.openDocList(item);
                this.openLogList(item);
              }, 500);
            } else if (this.open_doc_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.openDocList(item);
            } else if (this.open_log_model_falg) {
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openLogList(item);
            }
          } else {
            item.selected = false;
          }
        });
      }
    },
    updateSetting(is_all_update) {
      this.setting_data.is_all_update = is_all_update;
      let _self = this;
      this.loading = true;
      axios
        .post("update_item_setting", this.setting_data)
        .then(function(response) {
          if (response.data.status) {
            _self.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
            _self.loading = false;
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
          _self.loading = false;
        });
    },
    openUploader(item) {
      this.setModal(true);
      this.setDocumentData({ key: "type", value: 7 });
      this.setDocumentData({ key: "o_id", value: item.item_id });
      this.setDocumentData({ key: "items", value: this.items });
      this.setDocumentData({ key: "item", value: item });
    },
    openDocList(item) {
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 7 });
      this.setDocumentData({ key: "o_id", value: item.item_id });
      this.setDocumentData({ key: "main_task_id", value: "0" });
      this.setDocumentData({ key: "child_task_id", value: "0" });
      this.setDocumentData({ key: "item", value: item });
      this.setDocumentData({ key: "form_name", value: "Item" });
      this.setDocumentData({ key: "item_name", value: item.item_name });
      this.setDocumentData({ key: "job_name", value: "" });
      this.setDocumentData({ key: "user_name", value: "" });
      this.setDocumentData({ key: "customer_name", value: "" });
      this.setDocumentData({ key: "bank_name", value: "" });
      this.setDocumentData({ key: "project_name", value: "" });
      this.setDocumentData({ key: "vendor_name", value: "" });
      this.setDocumentData({ key: "doc_module", value: "ITEM" });
    },
    openLogList(item) {
      this.setLogData({ key: "log_list_modal", value: true });
      this.setLogData({ key: "type", value: 7 });
      this.setLogData({ key: "o_id", value: item.item_id });
      this.setLogData({ key: "item", value: item });
      this.setLogData({ key: "form_name", value: "Item" });
      this.setLogData({ key: "item_name", value: item.item_name });
      this.setLogData({ key: "job_name", value: "" });
      this.setLogData({ key: "user_name", value: "" });
      this.setLogData({ key: "customer_name", value: "" });
      this.setLogData({ key: "bank_name", value: "" });
      this.setLogData({ key: "project_name", value: "" });
      this.setLogData({ key: "vendor_name", value: "" });
    },
    importData() {
      let _self = this;
      this.import_dailog_loading = true;
      let formData = new FormData();
      formData.append("csv_file", this.selected_file);
      axios
        .post("import_item", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          if (response.data.status) {
            _self.getItems();
            _self.import_dailog_loading = false;
            _self.import_dailog = false;
            _self.selected_file = null;
            _self.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
          _self.import_dailog_loading = false;
        });
    },
    addRecord() {
      this.setItemData({ key: "add_item_modal", value: true });
    },
    editRecord(item_id, is_view_mode) {
      this.setItemData({ key: "edit_item_modal", value: true });
      this.setItemData({ key: "id", value: item_id });
      this.setItemData({ key: "is_view_mode", value: is_view_mode });
    },
    getAlphabets() {
      this.loading = true;
      axios.get("get_alphabets?flag=item").then(response => {
        if (response.data.status) {
          this.alphabets = response.data.data;
        }
        this.loading = false;
      });
    },
    activeImage(active_image_index) {
      this.active_image_index = active_image_index;
    },
    deleteImage() {
      let _self = this;
      axios
        .post("delete_item_image", {
          id: _self.images[_self.active_image_index].item_img_id
        })
        .then(function() {
          _self.images.splice(_self.active_image_index, 1);
          _self.active_image_index = 0;
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    expandRow(itemData) {
      if (itemData.value) {
        this.items.data = this.items.data.map(function(item) {
          if (item.item_id == itemData.item.item_id) {
            item.expande_icon = "mdi-chevron-up";
            item.selected = true;
          } else {
            item.expande_icon = "mdi-chevron-down";
          }
          return item;
        });
      } else {
        this.items.data = this.items.data.map(function(item) {
          item.expande_icon = "mdi-chevron-down";
          return item;
        });
      }
    },
    getVendor(vendors) {
      let types = vendors.map(item => {
        //return `${item.vendor.v_name} (Inv. Price: ${item.invoice_price}, Dev. Price: ${item.deliver_price}, Sal. Price: ${item.sales_price})<br>`
        return `<b>Name:</b> ${item.vendor.v_name} <b>Inv. Price:</b> ${
          item.invoice_price
        } <b>Dev. Price:</b> ${item.deliver_price} <b>Sal. Price:</b> ${
          item.sales_price
        } <b>Price Override: </b> ${
          item.price_override ? item.override_price : "false"
        } <br>`;
      });
      return types.join("");
    },
    deleteItems() {
      let _self = this;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.item_id);
      });
      axios
        .post("delete_items", {
          ids: ids
        })
        .then(function(response) {
          _self.setAlert({
            show: true,
            variant: response.data.variant,
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.getItems();
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getItems() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios
        .get("items_list?" + url)
        .then(response => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.alphabets = response.data.alphabets;
          _self.group_list = response.data.groups;
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    getItemSettings() {
      //let _self = this
      //this.loading = "accent";
      axios
        .get("get_item_setting")
        .then(response => {
          let data = response.data.data;
          for (let key in data) {
            this.setting_data[key] = data[key] == null ? "" : data[key];
          }
          //_self.loading = false;
        })
        .catch(function() {
          //this.loading = false;
        });
    },
    previewImage(images) {
      this.images = images;
      this.preview_image_dialog = true;
    },
    getItemGroup() {
      axios
        .get("get_item_groups")
        .then(response => {
          if (response.data.status) {
            this.assign_group_list = response.data.item_group;
            // if(this.getTotalStoneCount>0){
            //   this.assign_group_list = response.data.stone_group;
            // }
            // if(this.getTotalItemCount>0){
            //   this.assign_group_list = response.data.item_group;
            // }
          }
        })
        .catch(function() {});
    },
    assignGroupDialog() {
      this.selected_group = "";
      this.getItemGroup();
      this.assign_group_dialog = true;
    },
    assignGroups() {
      let _self = this;
      let ids = [];
      _self.selectedRows.map(function(item) {
        ids.push(item.item_id);
      });
      _self.form_loading = true;
      axios
        .post("assign_group_to_item", { group: this.selected_group, ids: ids })
        .then(response => {
          console.log(response);
          _self.assign_group_dialog = false;
          _self.getItems();
          _self.form_loading = false;
        })
        .catch(function() {
          _self.form_loading = false;
        });
    },
    logout() {
      logout(this.$router);
    }
  },
  mounted: function() {
    //this.getAlphabets();
    this.getItemSettings();
  }
};
</script>

<style>
</style>